import classNames from "@casino/external/classNames";
import styles from "./styles/OtherButtonsContainer.module.css";

type Props = React.HTMLAttributes<HTMLDivElement>;

const OtherButtonsContainer: FC<Props> = ({ className, ...rest }) => (
  <div className={classNames(styles.container, className)} {...rest} />
);

export default OtherButtonsContainer;
